<template>
  <div v-if="ready">
    <div class="loader" v-images-loaded="onImageLoad">
      <img src="/images/company/left.jpg" />
      <img src="/images/company/team.jpg" />
    </div>
    <div class="index" ref="index">
      <Navigation />
    </div>
    <div class="container">
      <div class="container__center">
        <div class="home center__container">
          <section class="home__main">
            <div class="home__main__left">
              <h1 class="home__title">
                <router-link
                    :event="''"
                    :to="{ name: 'projects', params: { activeSection: 'architecture' } }"
                    @click.native.prevent="onFollowLink( { name: 'projects', params: { activeSection: 'architecture' } } )"
                    class="a-link"
                  ><div class="">{{ $t('section_architecture') }}</div></router-link>
                <router-link
                    :event="''"
                    :to="{ name: 'projects', params: { activeSection: 'design' } }"
                    @click.native.prevent="onFollowLink( { name: 'projects', params: { activeSection: 'design' } } )"
                    class="a-link"
                  ><div class="">{{ $t('section_design') }}</div></router-link>
              </h1>
              <div class="main__link pc__only">
                <router-link
                  :to="{
                    name: 'project',
                    params: { projectSlug: sliderLink.url },
                  }"
                  @click.native.prevent="
                    onFollowLink({
                      name: 'project',
                      params: { projectSlug: sliderLink.url },
                    })
                  "
                >
                  <svg
                    width="31"
                    height="17"
                    viewBox="0 0 31 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M23.8013 0.818191L30.6833 7.73182C31.1056 8.15607 31.1056 8.84393 30.6833 9.26818L23.8013 16.1818C23.379 16.6061 22.6943 16.6061 22.272 16.1818C21.8497 15.7576 21.8497 15.0697 22.272 14.6454L27.3079 9.58637L1.0814 9.58637C0.484157 9.58637 0 9.09999 0 8.5C0 7.90001 0.484157 7.41363 1.0814 7.41363L27.3079 7.41363L22.272 2.35455C21.8497 1.9303 21.8497 1.24245 22.272 0.818191C22.6943 0.393936 23.379 0.393936 23.8013 0.818191Z"
                      fill="currentColor"
                    />
                  </svg>
                  {{ sliderLink.name }}
                </router-link>
              </div>
            </div>
						<Splide v-if="ready" :options="{ rewind: true, perPage: 1, arrows: true }" class="index-screen__slider" aria-label="Vue Splide Example" ref="slider">
							<SplideSlide class="index-screen__slider__item"
							v-for="(slide, index) in slidesData"
							:key="index"
							:style="`background-image: url(${slide.image});`">
							</SplideSlide>
						</Splide>
            <router-link
              :to="{
                name: 'project',
                params: { projectSlug: sliderLink.url },
              }"
              @click.native.prevent="
                onFollowLink({
                  name: 'project',
                  params: { projectSlug: sliderLink.url },
                })
              "
              class="arrow__link mobile__only"
            >
              <div>{{ sliderLink.name }}</div>
              <svg
                width="31"
                height="17"
                viewBox="0 0 31 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M23.8013 0.818191L30.6833 7.73182C31.1056 8.15607 31.1056 8.84393 30.6833 9.26818L23.8013 16.1818C23.379 16.6061 22.6943 16.6061 22.272 16.1818C21.8497 15.7576 21.8497 15.0697 22.272 14.6454L27.3079 9.58637L1.0814 9.58637C0.484157 9.58637 0 9.09999 0 8.5C0 7.90001 0.484157 7.41363 1.0814 7.41363L27.3079 7.41363L22.272 2.35455C21.8497 1.9303 21.8497 1.24245 22.272 0.818191C22.6943 0.393936 23.379 0.393936 23.8013 0.818191Z"
                  fill="#000000"
                />
              </svg>
            </router-link>
          </section>

          <section class="home__desc">
            <h2 class="desc__left">
              We create successful projects for business – focused on the person and serving the humanity
            </h2>
            <div class="desc__right">
              <div class="desc__text">
                AD Сasa is a studio with a wealth of experience in hospitality, creating and implementing relevant ideas in architecture and design.<br /><br />
                A competent team focused at work on local culture and traditions interconnecting in the mix with modern tendencies. 
                Love for our work and creative vision helps us translate ideas and thoughts into reality, for comfortable spaces for life, work, creativity and leisure.
              </div>
              <router-link
                :to="{ name: 'company' }"
                :event="''"
                @click.native.prevent="onFollowLink({ name: 'company' })"
                class="arrow__link"
              >
                <div>About us</div>
                <img src="/images/arrow_right.svg" alt="" />
              </router-link>
            </div>
          </section>

          <div class="page__footer">
            <div class="footer__grey__block"></div>
            AD сasa | Architecture&Design ©{{ new Date().getFullYear() }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { globalMixin, scrollMixin, pageArrowMixin } from "../mixins"
import Vue from "vue"
import Navigation from "../components/Navigation.vue"
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import '@splidejs/splide/dist/css/splide.min.css'

export default {
  mixins: [globalMixin, scrollMixin, pageArrowMixin],

  components: {
    Navigation,
		Splide, 
		SplideSlide
  },

  data() {
    return {
      ready: false,
      readyTeam: false,
      filterColor: "white",
      slidesData: [],
      activeTab: 0,
      slidesArray: [],
      sliderLink: {
        name: "",
        url: "",
      },
    };
  },

  computed: {
    navigationColor() {
      return "black";
    },
  },

  methods: {
    onChangeSlide(id) {
      this.sliderLink = {
        name: this.slidesArray[id].description,
        url: this.slidesArray[id].projectSlug,
      };
    }
  },

  mounted() {

    this.$http
      .get(this.getApiURL(`getSlidesList?lang=${Vue.i18n.locale()}`))
      .then((response) => {
        this.ready = true;
        this.slidesData = response.data;
        this.slidesArray = response.data;
        this.sliderLink = {
          name: this.slidesArray[0].description,
          url: this.slidesArray[0].projectSlug,
        };
				setTimeout(() => {
					this.$refs.slider.splide.on('move', (newIndex) => {
						this.onChangeSlide(newIndex)
					})
				})
      });
  },
};
</script>

<style lang="scss">
@import "../assets/vars.scss";

.index__menu {
  position: absolute;
  z-index: 3;
  left: 0;
  right: 0;
  top: 0;
  text-align: center;
  color: #303030;
  transition: all .2s ease;

  &.isHiddenByScroll {
    transform: translateY(-100%);
  }

  &.isWithBackground {
    background: #F4F4F4;
  }

  @media #{$mb} {
    height: 74px;
  }

  &__list {
    @media #{$mb} {
      display: none;
    }
  }
}

.index__menu__lang {
  position: absolute;
  top: rem(37px);
  right: rem(140px);
  font-weight: 500;
  font-size: rem(18px);
  color: inherit;
  letter-spacing: 0.38px;
  line-height: rem(24px);
  text-decoration: none;
  text-transform: lowercase;

  @media #{$mb} {
    top: 1.1125rem;
    right: 3.75rem;
    font-weight: 500;
    font-size: 0.8rem;
  }

  &:first-letter {
    text-transform: uppercase;
  }
}

.index__menu__list {
  padding: rem(30px) 0;
  font-size: 0;
}

.index__menu__link {
  display: inline-block;
  margin-right: rem(107px);
  font-size: rem(16px);
  color: inherit;
  letter-spacing: -0.03em;
  line-height: rem(24px);
  text-decoration: none;

  &:last-child {
    margin-right: 0;
  }
}

.home__desc {
  padding-top: rem(145px);
  display: flex;

  @media #{$mb} {
    padding-top: rem(80px);
    flex-direction: column;
  }

  .desc__left {
    display: block;
    margin: 0;
    padding: 0;
    margin-right: 45px;
    font-family: "Didot";
    font-style: normal;
    font-weight: 400;
    font-size: 40px;
    line-height: 120%;
    width: 403px;
    min-width: 403px;
    transform: translateY(-14px);
    @media #{$mb} {
      width: 100%;
      min-width: auto;
    }
    @media (max-width: 1055px) {
      min-width: 30%;
    }
  }

  .desc__right {
    display: flex;
    flex-direction: column;
    gap: 70px;
    max-width: 650px;
    @media #{$mb} {
      gap: 20px;
    }
  }

  .arrow__link {
    display: flex;
    align-items: center;
    width: fit-content;
    gap: 25px;
    font-style: normal;
    font-weight: 400;
    font-size: 26px;
    line-height: 120%;
    text-decoration: none;
    color: inherit;
    div {
      position: relative;
      &:hover {
        &:before {
          content: "";
          position: absolute;
          width: 100%;
          bottom: 2px;
          left: 0;
          border-bottom: 1px solid rgba(38, 38, 38, 1);
        }
      }
      &:before {
        content: "";
        position: absolute;
        width: 0%;
        bottom: 2px;
        left: 0;
        border-bottom: 1px solid rgba(38, 38, 38, 1);
        transition: 0.2s;
      }
      &::after {
        content: "";
        position: absolute;
        width: 100%;
        bottom: 2px;
        left: 0;
        border-bottom: 1px solid rgba(38, 38, 38, 0.1);
      }
    }
    
    @media #{$mb} {
      margin-top: rem(40px);
    }
  }

  .desc__text {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 120%;
    letter-spacing: -0.03em;
    @media #{$mb} {
      margin-top: rem(45px);
    }
  }
}

.home__main {
  display: flex;

  .arrow__link {
    display: flex;
    align-items: center;
    width: fit-content;
    gap: 25px;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 130%;
    text-decoration: none;
    color: inherit;
    transition: 0.2s;
    color: #000000;
    div {
      position: relative;
      &:hover {
        &:before {
          content: "";
          position: absolute;
          width: 100%;
          bottom: 2px;
          left: 0;
          border-bottom: 1px solid rgba(38, 38, 38, 1);
        }
      }
      &:before {
        content: "";
        position: absolute;
        width: 0%;
        bottom: 2px;
        left: 0;
        border-bottom: 1px solid rgba(38, 38, 38, 1);
        transition: 0.2s;
      }
      &::after {
        content: "";
        position: absolute;
        width: 100%;
        bottom: 2px;
        left: 0;
        border-bottom: 1px solid rgba(38, 38, 38, 0.1);
      }
    }
    @media #{$mb} {
      margin-top: 30px;
    }
  }

  .pc__only {
    @media #{$mb} {
      display: none;
    }
  }

  @media #{$mb} {
    flex-direction: column;
  }

  .home__main__left {
    margin-right: 45px;
    width: 403px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media #{$mb} {
      width: 100%;
      margin-right: 0px;
      margin-bottom: 53px;
      gap: 20px;
    }
  }

  .main__link a {
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-family: "Graphik LCG";
    font-style: normal;
    font-weight: 400;
    font-size: 26px;
    line-height: 130%;
    letter-spacing: -0.03em;
    color: #000000;
    text-decoration: none;
    position: relative;
    width: fit-content;
    &:hover {
      &:before {
        content: "";
        position: absolute;
        width: 100%;
        bottom: 2px;
        left: 0;
        border-bottom: 1px solid rgba(38, 38, 38, 1);
      }
    }
    &:before {
      content: "";
      position: absolute;
      width: 0%;
      bottom: 2px;
      left: 0;
      border-bottom: 1px solid rgba(38, 38, 38, 1);
      transition: 0.2s;
    }
    &::after {
      content: "";
      position: absolute;
      width: 100%;
      bottom: 2px;
      left: 0;
      border-bottom: 1px solid rgba(38, 38, 38, 0.1);
    }
  }


  .mobile__only {
    display: none;
    @media #{$mb} {
      display: inherit;
    }
  }

  .home__title {
    font-family: "Didot";
    font-style: normal;
    font-weight: 400;
    font-size: rem(70px);
    line-height: 138%;
    display: block;
    margin: 0;
    padding: 0;
    // transform: translateY(-17px);
    @media #{$mb} {
      font-size: 54px;
      transform: translateY(0);
    }
    div {
      width: fit-content;
      position: relative;
      &:hover {
        &:before {
          content: "";
          position: absolute;
          width: 100%;
          bottom: 11px;
          left: 0;
          border-bottom: 1px solid rgba(38, 38, 38, 1);
        }
      }
      &:before {
        content: "";
        position: absolute;
        width: 0%;
        bottom: 11px;
        left: 0;
        border-bottom: 1px solid rgba(38, 38, 38, 1);
        transition: 0.2s;
      }
      &::after {
        content: "";
        position: absolute;
        width: 100%;
        bottom: 11px;
        left: 0;
        border-bottom: 1px solid rgba(38, 38, 38, 0.1);
      }
    }
  }
}

.home {
  padding-top: rem(140px);
  @media #{$mb} {
    padding-top: rem(80px);
    flex-direction: column-reverse;
  }
}

.index-screen__slider {
  width: 873px;
  height: 563px;
  position: relative;
	overflow: hidden;
  @media #{$mb} {
    width: 100%;
    height: 216px;
  }
}

.splide__track {
	height: 100%;
}

.splide.is-active .splide__list {
	position: relative;
	height: 100%;

	li {
		display: flex;
		height: 100%;
	}
}

.index-screen__slider__item {
  background-position: center;
  background-size: cover;
  height: 100%;
}

.splide__pagination {
	bottom: 30px;

  @media #{$mb} {
    bottom: 12px;
  }
}

.splide__pagination__page {
	margin: 0 11px;
	border-radius: 40px;
	width: 8px;
	height: 8px;
  background: white;
  opacity: 1;
	will-change: transform;
  transform: scale(1);
  transition: transform 0.2s;

	&:hover {
		opacity: 1;
	}
}

.splide__pagination__page.is-active {
  transform: scale(1.3);
}

.splide__arrow {
  width: 50%;
  height: 100%;
	opacity: 0;
	border-radius: 0;

	@media #{$mb} {
    display: none;
  }
}

.splide__arrow--prev {
	left: 0;
	right: unset;
	cursor: url(/images/mouse-arrow-left.png) 15 15,auto;
	&:hover {
		opacity: 0;
		cursor: url(/images/mouse-arrow-left.png) 15 15,auto;
	}
}

.splide__arrow--next {
	left: unset;
	right: 0;
	cursor: url(/images/mouse-arrow-right.png) 15 15, auto;
	&:hover {
		opacity: 0;
		cursor: url(/images/mouse-arrow-right.png) 15 15, auto;
	}
}
</style>
